import React, { useEffect, useState } from "react";
import Button from "../../component/Button";
import { useLocation, useNavigate } from "react-router-dom";
import SearchBox from "../../component/SearchBox";
import LoyaltyProgramList from "./components/LoyaltyProgramList";
import SuccessModal from "../../modalComponents/SuccessModal";
import AddMembership from "../../modalComponents/AddMemberShip";
import classes from "./style.module.scss";
import ViewLoyalties from "./components/ViewLoyalties";
import Exported from "../../service/endpoints";
import request from "../../service";
import { Toast } from "../../service/toast";
import { saveLoadingState } from "../../redux/reducers/loadingSlice";
import { useDispatch } from "react-redux";

const LoyaltyProgram = () => {
  const [addMembershipModal, setAddMembershipModal] = useState(false);
  const [viewLoyalty, setViewLoyalty] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [programList, setProgramList] = useState({});
  const [isLoading, setisLoading] = useState(false);
  const [sortConfig, setSortConfig] = useState(null);
  const [selectedMembership, setSelectedMembership] = useState(null);
  const [page, setPage] = useState(1);
  const [isEdit, setIsEdit] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const pathName = location?.search?.split("?type=")?.at(1);
    if(pathName == 'add') {
      setAddMembershipModal(true)
    }
  }, [location])

  const getLoyaltyProgamId = () => {
    const pathName = location?.search?.split("?id=");
    const params = pathName?.length > 1 ? pathName[pathName?.length - 1] : null;
    return params;
  };

  const handleChange = (value) => {
    setSearchInput(value);
  };

  const handleClose = () => {
    setAddMembershipModal(false);
    redirectBack();
  };

  const handleSuccess = () => {
    handleClose();
    setShowSuccessModal(true);
  };

  const redirectBack = () => {
    navigate(`/admin/loyalty-program`);
  };

  const redirectTo = () => {
    navigate(`?type=add`);
  };

  const getLoyaltyInfo = (id) => {
    const selectedProgram = programList?.result?.find(
      (program) => program.id === id
    );
    if (selectedProgram) {
      setSelectedMembership(selectedProgram);
      setViewLoyalty(true);
      navigate(`?id=${id}`);
    }
  };

  const handleCloseLoyalty = () => {
    setViewLoyalty(false);
    redirectBack();
  };

  const handleSuccessLoyalty = () => {
    setAddMembershipModal(true);
    setViewLoyalty(false);
    redirectTo();
  };

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    redirectBack();
  };

  const getLoyaltyProgramList = async () => {
    setisLoading(true);
    let url = `${Exported.Endpoints.getLoyaltyProgram}`;
    let paramsObj = {
      page: page,
      limit: 10,
    };

    if (searchInput && searchInput !== "") {
      paramsObj["search"] = searchInput;
    }
    if (sortConfig) {
      paramsObj["sort"] = sortConfig?.key;
      paramsObj["sortOrder"] = sortConfig?.direction;
    }

    await request({
      url: url,
      params: { ...paramsObj },
    })
      .then((res) => {
        if (res?.data?.status) {
          const obj = {
            result: res?.data?.data,
            // pageMeta: res?.data?.data?.pageMeta,
          };
          setProgramList(obj);
        }
      })
      .catch((err) => {
        Toast({
          type: "error",
          message: "Unable to process the request!..",
        });
      });
    setisLoading(false);
  };

  useEffect(() => {
    getLoyaltyProgramList();
  }, [page]);

  // const handleDelete = async (id) => {
  //   dispatch(saveLoadingState(true));
  //   let url = `${Exported.Endpoints.getLoyaltyProgram}/${id}`;

  //   const requestData = {
  //     id: id,
  //   };
  //   await request({
  //     url: url,
  //     method: Exported.APIMethods.DELETE,
  //     data: requestData,
  //   })
  //     .then(async (res) => {
  //       if (res?.data?.status) {
  //         await getLoyaltyProgramList();
  //         Toast({
  //           type: "success",
  //           message: "Deleted successfully",
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       Toast({
  //         type: "error",
  //         message: "Unable to process the request!..",
  //       });
  //     });
  //   dispatch(saveLoadingState(false));
  // };

  return (
    <>
      <div className={`${classes.loyaltyProgramWrapper}`}>
        <div className={`w-[100%] flex items-center justify-between`}>
          <div className={`layout-title`}>Loyalty Program</div>
          <div className="flex items-center">
            <SearchBox
              className={"mr-5"}
              value={searchInput}
              onChange={handleChange}
              placeholder={"Find by membership name..."}
            />
            {/* <Button
              text={"Add Membership"}
              className={"!px-4"}
              smallBtn
              onClick={() => {redirectTo();setAddMembershipModal(true)}}
            /> */}
          </div>
        </div>
        <div>
          <LoyaltyProgramList
            setAddMembershipModal={setAddMembershipModal}
            handleView={getLoyaltyInfo}
            isLoading={isLoading}
            setisLoading={setisLoading}
            sortConfig={sortConfig}
            setSortConfig={setSortConfig}
            page={page}
            setPage={setPage}
            programList={programList}
          />
        </div>
      </div>
      {viewLoyalty ? (
        <ViewLoyalties
          selectedMembership={selectedMembership}
          programList={programList}
          isOpen={viewLoyalty}
          closePopUp={handleCloseLoyalty}
          handleSuccessModal={handleSuccessLoyalty}
          id={getLoyaltyProgamId()}
        />
      ) : null}

      {addMembershipModal ? (
        <AddMembership
          isOpen={addMembershipModal}
          closePopUp={handleClose}
          handleSuccessModal={handleSuccess}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          getLoyaltyProgramList={getLoyaltyProgramList}
          id={getLoyaltyProgamId()}
        />
      ) : null}
      {showSuccessModal ? (
        <SuccessModal
          isOpen={showSuccessModal}
          closePopUp={handleSuccessModalClose}
          successText={"Success!"}
          boxAlign="center"
          modalText={"New Reward details updated successfully"}
        />
      ) : null}
    </>
  );
};

export default LoyaltyProgram;
